import { Link } from "react-router-dom";
import { useState } from "react";
import "./Navbar.css";

function Navbar({ handleNavbarClick }) { // Make sure to receive handleNavbarClick as a prop
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <nav className="navbar">
      <div className="container navbar-container">
        <div className="navbar-logo">
          <img src="/images/babitapacklogo.png" alt="Babita Pack Logo" />
        </div>

        <div className={`navbar-menu ${isOpen ? "active" : ""}`}>
          <Link
            to="#about"
            className="navbar-link"
            onClick={() => handleNavbarClick("about")}  
          >
            About
          </Link>
          <Link
            to="#services"
            className="navbar-link"
            onClick={() => handleNavbarClick("services")}
          >
            Services
          </Link>
          <Link
            to="#portfolio"
            className="navbar-link"
            onClick={() => handleNavbarClick("portfolio")}
          >
            Portfolio
          </Link>
          <Link
            to="#contact"
            className="navbar-link"
            onClick={() => handleNavbarClick("contact")}
          >
            Contact
          </Link>
        </div>

        <div className="navbar-actions">
          <button className="icon-button">
            <i className="fas fa-search"></i>
          </button>
          <button className="icon-button">
            <i className="fas fa-bell"></i>
          </button>
          <button className="login-button">
            <i className="fas fa-user"></i>
            <span>Login</span>
          </button>
          <button className="menu-toggle" onClick={toggleMenu}>
            <i className={`fas ${isOpen ? "fa-times" : "fa-bars"}`}></i>
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;